class PublicReservationHelper {
  static formatCustomDate(
    timestring,
    daystring,
    monthstring,
    servicestarttime
  ) {
    // Given values
    const day = daystring; // update as needed
    const month = monthstring; // March is 2 (0-indexed in JS Date)
    const year = new Date().getFullYear(); // or any specific year
    const time = timestring; // e.g. "2:30pm"

    // Combine into a full date string
    const dateStr = `${year}-${month}-${day} ${time}`;

    // Create Date object
    const dateObj = new Date(dateStr);

    // Convert the servicestarttime to a Date object for comparison
    const serviceStart = new Date(
      `${year}-${month}-${day} ${servicestarttime}`
    );

    // If the selected time is earlier than the service start time, add one day to the date
    if (dateObj < serviceStart) {
      dateObj.setDate(dateObj.getDate() + 1); // Add one day
    }

    // Custom formatting
    const options = {
      weekday: "long",
      day: "numeric",
      month: "long",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    };

    const userLocale = navigator.language || navigator.userLanguage;
    const formatted = new Intl.DateTimeFormat(userLocale, options).format(
      dateObj
    );

    // Output in desired format (e.g. "Tuesday 25 March 2:30pm")
    return formatted;
  }

  static getReservationDateTime(
    timestring,
    daystring,
    monthstring,
    servicestarttime
  ) {
    // Given values
    const day = daystring; // update as needed
    const month = monthstring; // Month is 1-indexed in the input
    const year = new Date().getFullYear(); // or any specific year
    const time = timestring; // e.g. "2:30pm"

    // Combine into a full date string
    const dateStr = `${year}-${month}-${day} ${time}`;

    // Create Date object
    const dateObj = new Date(dateStr);

    // Convert the servicestarttime to a Date object for comparison
    const serviceStart = new Date(
      `${year}-${month}-${day} ${servicestarttime}`
    );

    // If the selected time is earlier than the service start time, add one day to the date
    if (dateObj < serviceStart) {
      dateObj.setDate(dateObj.getDate() + 1); // Add one day
    }

    // Convert the date to UTC
    const utcDate = new Date(dateObj.toUTCString());

    return utcDate;
  }
}

export default PublicReservationHelper;
